
export function refreshFavouriteIngButtons(name){
    const button = document.querySelector(`.favourite[data-name="${name}"]`);
};